export default __webpack_public_path__ + "static/Optima Medium-0d2173d7e3238d55651934090060d056.ttf";